export const SAMPLE_QUOTE = {
  quote_number: 'QT-987654',
  passenger_count: 4,
  valid_until: '2026-10-31T23:59:59Z',
  departure_airport: 'TEB',
  arrival_airport: 'MIA',
  client: {
    first_name: 'Sarah',
    last_name: 'Mitchell',
    email: 'sarah@example.com',
  },
  bid_items: [
    {
      bid: {
        passenger_count: 4,
        leg_itinerary: [
          { departure_airport: 'MIA', arrival_airport: 'TEB', departure_date: '2025-10-25T20:00:00Z', arrival_date: '2025-10-25T22:45:00Z', flight_time: '2h 45m', distance_nm: 955 },
          { departure_airport: 'TEB', arrival_airport: 'MIA', departure_date: '2025-10-28T14:00:00Z', arrival_date: '2025-10-28T16:50:00Z', flight_time: '2h 50m', distance_nm: 955 },
        ],
        bid_options: [
          {
            shortlisted: true,
            bid_option_id: 'opt-001',
            final_price: 38070,
            federal_excise_tax: 2915.25,
            segment_tax: 91.20,
            aircraft_id: 'ac-001',
            aircraft: {
              tail_number: 'N123GT',
              make_model: 'Hawker 800SP',
              aircraft_make_model: { manufacturer: 'Hawker', make_model: 'Hawker 800SP' },
              image_urls: ['https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=800&q=80'],
              description:
                "This Hawker 800SP offers exceptional comfort and performance for your journey. With a range of 2,640 nautical miles and seating for up to 10 passengers, it's perfect for your TEB to MIA flight.",
              aircraft_features: {
                no_aog: true,
                custom_features: ['WIFI', 'ENTERTAINMENT SYSTEM', 'FULL GALLEY', 'ENCLOSED LAVATORY', 'SATELLITE PHONE'],
              },
            },
            operator: {
              name: 'Skyward Aviation',
              city: 'Teterboro',
              state: 'NJ',
              argus_rating: 'Platinum',
              wyvern_rating: 'Wingman',
            },
          },
        ],
      },
    },
  ],
};

export const SAMPLE_PASSENGERS = [
  { first_name: 'Arthur', last_name: 'Taylor' },
  { first_name: 'Sophie', last_name: 'Williams' },
  { first_name: 'Ravi', last_name: 'Patel' },
];

export const SAMPLE_CREW = {
  pic: { first_name: 'Matthew', last_name: 'Kennedy', phone: '+1 903-976-0632' },
  sic: { first_name: 'Rachelle', last_name: 'Stewart', phone: '+1-303-650-0945' },
};

export const SAMPLE_SERVICES = [
  { name: 'Catering', icon: 'plane', details: 'In-House', address: '-', phone: '+1 (888) 478-7344', confirmation_number: 'RSHe5S6T' },
  { name: 'Transportation', icon: 'plane', details: 'Limousine', address: '-', phone: '+1 (855) 478-701', confirmation_number: 'A7CX7TJI' },
];
